<template>
  <overview/>
</template>

<script>
  import Overview from '../components/Overview'

  export default {
    name: 'OverviewPage',

    components: {
      Overview,
    },
  }
</script>
